import { useEffect, useState } from "react";
import ClubTable from "../../../components/club-table/ClubTable";
import ClubControls from "../../../components/club-controls/ClubControls";
import Modal from "../../../components/Modal/Modal";
import { useHookstate } from "@hookstate/core";
import { useUniversalFindAll } from "../../../hooks/universal";
import { Club as ClubType, ClubState } from "../../../types";
import {
  accessGlobalMiscState,
  useGlobalMiscState,
} from "../../../stores/misc";
import ClubForm from "../../../components/club-form/ClubForm";
import { exportToExcel, getClubMeta } from "../../../misc/utils";
import { clubMeta, clubsExcel } from "../../../misc/constants";
import { useClubs } from "../../../hooks/club";

const Club = ({ clubType }: { clubType: any }) => {
  const miscState = useGlobalMiscState();
  const allClubsTriggerFetch = miscState.get("allClubsTriggerFetch") || 0;
  const clubFormVisible = Boolean(miscState.get("clubFormVisible"));
  const clubsAmount = miscState.get(`clubsAmount_${clubType?.id}`) || 0;
  const localState = useHookstate<ClubState>({} as ClubState);
  const state = localState.get();
  const clubTypeMeta = state.clubTypeMeta || clubMeta[0];
  const allClubs: ClubType[] = useClubs(clubType?.id, allClubsTriggerFetch);

  useEffect(() => {
    if (clubType?.id) {
      localState.merge({
        clubType,
        clubTypeMeta: getClubMeta(clubType.name),
      });
    }
  }, [clubType?.id]);

  const setIsAddClubOpen = (value: boolean) => {
    accessGlobalMiscState().set("clubFormVisible", value);
  };

  const onExport = () => {
    exportToExcel(
      `${clubTypeMeta.pageTitle.replaceAll(" ", "_").toLowerCase()}_report`,
      allClubs,
      clubsExcel
    )();
  };
  return (
    <>
      <div className='p-5 bg-sky-50 h-full overflow-y-auto'>
        <h1 className='text-5xl pb-5 font-bold text-black'>
          {clubTypeMeta.pageTitle} ({clubsAmount})
        </h1>
        <div className='rounded-lg bg-white p-5 overflow-y-auto'>
          <ClubControls
            localState={localState}
            handleOpenAddClub={setIsAddClubOpen}
            onExport={onExport}
          />

          <ClubTable localState={localState} />
        </div>
      </div>

      <Modal
        visible={clubFormVisible}
        setVisible={setIsAddClubOpen}
        additionalClassName='lg:w-[41%]'
      >
        <ClubForm clubType={clubType} setVisible={setIsAddClubOpen} />
      </Modal>
    </>
  );
};

export default Club;
